export default {
  CURRENT_QUIZ_UPDATED: (state, quiz) => {
    state.currentQuiz = quiz
  },

  PREVIOUS_QUIZ_ATTEMPTS_UPDATED: (state, attempts) => {
    state.previousAttempts = attempts
  },

  STARTED_QUIZ_ATTEMPT: (state, attempt) => {
    state.currentAttempt = attempt
  },

  FINISHED_QUIZ_ATTEMPT: (state, attempt) => {
    state.finishedAttempt = attempt
  },
}
